<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>TikTok Ads</h3>
      </div>
      <div class="box-content">
        <div v-if="!hasIntegration">
          <p>
            Configure as suas contas de anúncios no tiktok ads para computar os
            custos de marketing.
          </p>
          <div class="margin-top-s">
            <div class="button primary" @click="copyLink(urlWebhook)">
              Entrar com TikTok
            </div>
          </div>
        </div>

        <div v-else class="list-account">
          <!-- list accounts -->
          <p>
            Lista de contas de anúncio com acesso. Ative a conta que deseja ter
            os dados de custo no painel.
          </p>
          <ul class="margin-top-l">
            <li v-for="(acc, index) in accounts" :key="index">
              <div class="flex">
                <div class="flex-1">{{ acc.name }} ({{ acc.id }})</div>
                <div class="flex-1">
                  <div class="flex end">
                    <m-switch v-model="acc.status"></m-switch>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MSwitch from "@/components/MSwitch.vue";
export default {
  components: { MSwitch },
  name: "tiktok-ads",
  data() {
    return {
      status: true,
      accounts: [
        {
          id: 1000000001,
          name: "Conta 1",
          status: true,
        },
        {
          id: 1000000002,
          name: "Conta 2",
          status: false,
        },
        {
          id: 1000000003,
          name: "Conta 3",
          status: true,
        },
      ],
    };
  },
  mounted() {},
  computed: {
    hasIntegration() {
      return this.status;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-account {
  ul {
    list-style-type: none;
    li {
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--border);
    }
  }
}
</style>
